/* ============================================================
   FRESH-ACADEMY · Shopify Theme · fresh-academy.js
   Vanilla JS — keine Frameworks.
   ============================================================ */
(function () {
  'use strict';

  // ----- Mobile Menu Toggle -----
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mobile-menu-toggle]');
    if (btn) {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', nav && nav.classList.contains('open') ? 'true' : 'false');
    }
  });

  // ----- Collection: Filter-Chips (Collection-Navigation) + Jahr-Filter -----
  function applyYearFilter() {
    var list = document.querySelector('[data-filter-target]');
    var yearSel = document.querySelector('[data-year-filter]');
    if (!list) return;
    var year = yearSel ? yearSel.value : 'all';
    list.querySelectorAll('[data-filter-value]').forEach(function (card) {
      var match = year === 'all' || (card.dataset.year || '').indexOf(year) !== -1;
      card.style.display = match ? '' : 'none';
    });
  }
  // Beim Laden: ?year= aus der URL uebernehmen (fuer Jahr-Erhalt beim Collection-Wechsel)
  (function () {
    var yearSel = document.querySelector('[data-year-filter]');
    if (!yearSel) return;
    var y = new URLSearchParams(window.location.search).get('year');
    if (y) {
      var hasOpt = Array.prototype.some.call(yearSel.options, function (o) { return o.value === y; });
      if (hasOpt) yearSel.value = y;
    }
    applyYearFilter();
  })();
  // Jahr aendern: filtern + URL aktualisieren
  document.querySelectorAll('[data-year-filter]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      applyYearFilter();
      var url = new URL(window.location.href);
      if (sel.value && sel.value !== 'all') url.searchParams.set('year', sel.value);
      else url.searchParams.delete('year');
      history.replaceState(null, '', url);
    });
  });
  // Chip-Klick: aktuelles Jahr an die Ziel-Collection mitgeben ("Alle" resettet das Jahr)
  document.querySelectorAll('[data-filter-chips] [data-chip]').forEach(function (chip) {
    chip.addEventListener('click', function (e) {
      var yearSel = document.querySelector('[data-year-filter]');
      var year = yearSel ? yearSel.value : 'all';
      if (chip.hasAttribute('data-chip-all') || !year || year === 'all') return;
      e.preventDefault();
      var u = new URL(chip.getAttribute('href'), window.location.origin);
      u.searchParams.set('year', year);
      window.location.href = u.toString();
    });
  });

  // ----- Sort dropdown (legacy, page reload based) -----
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  });

  // ----- Tabs (product page) -----
  document.querySelectorAll('[data-tabs]').forEach(function (tabsEl) {
    tabsEl.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tab]');
      if (!tab) return;
      var key = tab.dataset.tab;
      tabsEl.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.toggle('active', t === tab); });
      var root = tabsEl.closest('[data-tab-root]') || document;
      root.querySelectorAll('[data-tab-panel]').forEach(function (p) {
        p.classList.toggle('active', p.dataset.tabPanel === key);
      });
    });
  });

  // ----- Variant Picker (product page) -----
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('.variant');
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      var id = btn.dataset.variantId;
      picker.querySelectorAll('.variant').forEach(function (b) { b.classList.toggle('active', b === btn); });
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput) idInput.value = id;
      }
      // update price
      var priceTarget = document.querySelector('[data-variant-price]');
      if (priceTarget && btn.dataset.variantPrice) priceTarget.innerHTML = btn.dataset.variantPrice;
      // update available
      var addBtn = document.querySelector('[data-add-to-cart]');
      if (addBtn) {
        var avail = btn.dataset.variantAvailable === 'true';
        addBtn.disabled = !avail;
        var lbl = addBtn.querySelector('[data-add-label]') || addBtn;
        lbl.textContent = avail ? (addBtn.dataset.labelAvailable || 'Jetzt buchen') : (addBtn.dataset.labelSoldout || 'Ausgebucht');
      }
    });
  });

  // ----- Quantity steppers -----
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      e.preventDefault();
      var step = parseInt(btn.dataset.qtyStep, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 9999;
      var v = parseInt(input.value, 10) || min;
      v = Math.max(min, Math.min(max, v + step));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ----- Cart line-item qty updates (uses Shopify /cart/change.js) -----
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name^="updates"]')) return;
      var line = parseInt(e.target.dataset.line, 10);
      var qty = parseInt(e.target.value, 10) || 0;
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.reload();
      });
    });
  });

  // Remove from cart
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var line = parseInt(btn.dataset.line, 10);
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  // ----- Info-Formular Lead-Capture (Customer-Form, kein Checkout) -----
  document.querySelectorAll('[data-info-form]').forEach(function (form) {
    // Shopify's customer/contact form posts natively – we just add nice loading state.
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet…'; }
    });
  });

  // ----- Newsletter-Form mit Make.com Webhook -----
  // Wenn data-newsletter-webhook am <form> gesetzt ist, POST direkt an Make.com
  // statt an Shopify. Payload-Struktur konsistent mit dem Infomaterial-Formular.
  document.querySelectorAll('form[data-newsletter-webhook]').forEach(function (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var url = form.getAttribute('data-newsletter-webhook');
      var blockId = form.getAttribute('data-block-id');
      var status = document.getElementById('newsletter-status-' + blockId);
      var email = form.querySelector('input[name="email"]');
      var btn = form.querySelector('button[type="submit"]');
      if (!email || !email.value.trim()) return;
      if (btn) btn.disabled = true;
      try {
        var payload = {
          email: email.value.trim(),
          source: 'website-footer-newsletter',
          tags: ['newsletter', 'footer-signup'],
          accepts_marketing: true,
          dsgvo_consent: true,
          submitted_at: new Date().toISOString(),
          submitted_at_local: new Date().toLocaleString('de-DE')
        };
        var res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!res.ok) throw new Error('Webhook ' + res.status);
        if (status) {
          status.textContent = 'Danke — du bist angemeldet.';
          status.style.color = 'var(--turquoise)';
          status.style.display = 'block';
        }
        form.style.display = 'none';
      } catch (err) {
        console.error('Newsletter submission error:', err);
        if (status) {
          status.textContent = 'Beim Senden hat etwas nicht geklappt. Bitte versuche es erneut.';
          status.style.color = 'var(--accent)';
          status.style.display = 'block';
        }
        if (btn) btn.disabled = false;
      }
    });
  });
})();
